(() => {
  function initializeLocalizationDrawer() {
    const details = document.getElementById('Details-localization-drawer');
    if (!details || details.dataset.initialized) return;
    details.dataset.initialized = 'true';
    const summary = details.querySelector('summary');
    const panel = details.querySelector('[role="dialog"]');
    const closeButton = panel.querySelector('.localization-drawer__close');
    let previousHeaders = [];
    let hadScrollLock = false;
    const close = () => { details.open = false; };

    closeButton.addEventListener('click', close);
    panel.addEventListener('keyup', (event) => {
      if (event.key !== 'Escape') return;
      // An expanded selector handles Escape first and stops propagation.
      event.stopPropagation();
      close();
    });
    panel.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(panel.querySelectorAll('button, a[href], input:not([type="hidden"]), [tabindex="0"]'))
        .filter((element) => !element.disabled && element.getClientRects().length);
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first?.focus();
      }
    });
    details.addEventListener('toggle', () => {
      summary.setAttribute('aria-expanded', String(details.open));
      if (details.open) {
        hadScrollLock = document.body.classList.contains('overflow-hidden');
        previousHeaders = Array.from(document.querySelectorAll('#shopify-section-header, .section-header, sticky-header'))
          .map((header) => [header, header.style.getPropertyValue('z-index'), header.style.getPropertyPriority('z-index')]);
        previousHeaders.forEach(([header]) => header.style.setProperty('z-index', '2147483647', 'important'));
        document.body.classList.add('overflow-hidden');
        closeButton.focus({ preventScroll: true });
      } else {
        panel.querySelectorAll('localization-form').forEach((form) => form.hidePanel?.());
        previousHeaders.forEach(([header, value, priority]) => {
          if (value) header.style.setProperty('z-index', value, priority);
          else header.style.removeProperty('z-index');
        });
        if (!hadScrollLock) document.body.classList.remove('overflow-hidden');
        summary.focus({ preventScroll: true });
      }
    });
  }
  initializeLocalizationDrawer();
  document.addEventListener('shopify:section:load', initializeLocalizationDrawer);
})();
